import React from 'react'
import FooterLink from './FooterLink'

const FooterSection = (item) => {
    return(
        <div className={`relative transition-all duration-300 px-6 lg:px-0 py-3 lg:py-0 lg:bg-transparent ${item.open ? "bg-blue-800" : "bg-transparent"}`} onClick={() => item.onClick(item._uid)} onKeyDown={() => item.onClick(item._uid)} role="button" tabIndex="0">
            { 
                <>
                    <h5 className={`font-display text-lg uppercase mb-2 transition duration-300 lg:text-white tracking-widest ${item.open ? "text-red" : "text-white"}`}>{item.label}</h5>
                    <i className={`fal transition-all duration-300 transform -translate-x-1/2 translate-y-1/2 absolute right-6 top-3 lg:!hidden ${item.open ? "text-red fa-minus" : "text-white fa-plus"}`}></i>
                </>
            }
            <div className={`transition-all ease-max-h duration-300 overflow-hidden lg:max-h-[1000px] ${item.open ? "max-h-[1000px]" : "max-h-0"}`}>
                {
                    item.links.map((link, index) => {
                        return (
                            <FooterLink {...link} key={index}/>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default FooterSection